/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Warm_Swan_FloatInputs */

const en_deep_warm_swan_float = /** @type {(inputs: Deep_Warm_Swan_FloatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text color`)
};

const de_deep_warm_swan_float = /** @type {(inputs: Deep_Warm_Swan_FloatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textfarbe`)
};

/**
* | output |
* | --- |
* | "Text color" |
*
* @param {Deep_Warm_Swan_FloatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_warm_swan_float = /** @type {((inputs?: Deep_Warm_Swan_FloatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Warm_Swan_FloatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_warm_swan_float(inputs)
	return de_deep_warm_swan_float(inputs)
});